import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ContentService {
  pages: Object = {
    "vittaa-app": {
      title: "Vittaa",
      description:
        "Designing an online meet up platform for people who want to run, bike or hike together.",
    },

    "kat-website": {
      title: "Knivesandtools",
      description:
        "Visual design for a web shop offering a wide range of kitchen and outdoor tools. ",
    },

    grailer: {
      title: "Grailer",
      description: "Branding a new private label for grail pocket knives.",
    },

    "logo-design": {
      title: "Logo design",
      description:
        "A small selection of logos and workmarks I made through the years.",
    },

    print: {
      title: "Print design",
      description: "Brochures, magazines, flyers. Print is still relevant.",
    },

    danvi: {
      title: "Danvi Coffee Roasters",
      description: "Creating a visual identity for a new coffee brand. ",
    },
    danvi2: {
      title: "Danvi Coffee Roasters",
      description: "Creating a visual identity for a new coffee brand. ",
    },
    ondergrondsverbond: {
      title: "Ondergronds Verbond",
      description: "Uniting diverse dance events. ",
    },
    aurea: {
      title: "Aurea Interior",
      description: "A visual language true to the brand. ",
    },
  };

  constructor() {}
}
